export const MAINTENANCE_ENABLED = window.MAINTENANCE === 'true';

export const SEARCH_DELAY_MILLISECONDS = 1000;

/**
 * Nombre maximum de codes postaux affichés sur la page de recherche avant formattage
 */
export const MAX_LENGTH_POSTAL_CODES = 3;

/**
 * Zoom initial pour la map des psychologues
 */
export const INITIAL_ZOOM_MAP = 12;
